/* eslint-disable no-nested-ternary */
import React from 'react';
import { Spin, Typography, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import useQuotesContext from './QuotesContext';
import useThemeContext from '../../contexts/ThemeContext';

const { Text } = Typography;

const EstimationCard = () => {
  const {
    exemptions,
    formValues,
    displayRestricted,
    estimatedCost,
    isEstimationLoading
  } = useQuotesContext();
  const { t } = useTranslation();
  const { leftCollapsed, rightCollapsed } = useThemeContext();

  const fractionType = {
    MONTHLY: 1,
    QUARTERLY: 3,
    BIANNUAL: 6,
    YEARLY: 12
  };

  const fractionTypeCost = (cost) => {
    return ((cost || 0) * fractionType[formValues?.fraction_type]).toFixed(2);
  };

  const isXSScreen = useMediaQuery({ query: '(max-width: 700px)' });

  // Classes dynamiques pour gérer left + right sidebars
  const getClassNames = () => {
    const classes = ['estimation-bar-fixed'];
    classes.push(leftCollapsed ? 'left-collapsed' : 'left-expanded');
    classes.push(rightCollapsed ? 'right-collapsed' : 'right-expanded');
    return classes.join(' ');
  };

  return (
    <div className={getClassNames()}>
      <div className="estimation-bar-content">
        {exemptions.length ? (
          <div className="exemption-message">
            <Text strong>
              Message: Conditions & tarifs personnalisés sous étude en ligne par
              notre service (réponse ultra-rapide!)
            </Text>
          </div>
        ) : (
          <Spin spinning={isEstimationLoading}>
            <Space
              direction={isXSScreen ? 'vertical' : 'horizontal'}
              size="large"
              align={isXSScreen ? 'start' : 'center'}
              className="estimation-space"
            >
              <div className="pricing-main">
                <span className="pricing-label">
                  {formValues?.activity_type ? 'Tarif TTC:' : 'Tarif:'}
                </span>
                <span className="pricing-amount">
                  {fractionTypeCost(estimatedCost.total_monthly_customer)}€
                </span>
                <span className="pricing-period">
                  /{t(`quotes.fraction_type.${formValues?.fraction_type}`)}
                </span>
              </div>

              {!displayRestricted && (
                <div className="pricing-details">
                  <Text type="secondary" className="pricing-commission">
                    {t('quotes.estimation_card')}{' '}
                    {fractionTypeCost(estimatedCost.remuneration)}€/
                    {t(`quotes.fraction_type.${formValues?.fraction_type}`)}
                  </Text>
                  <Text type="secondary" className="pricing-yearly">
                    Rémunération 1ère année:{' '}
                    {(
                      (estimatedCost.remuneration || 0) * 12 +
                      (formValues?.paperwork_fee || 0)
                    ).toFixed(2)}
                    €, années suivantes:{' '}
                    {((estimatedCost.remuneration || 0) * 12).toFixed(2)}€
                  </Text>
                </div>
              )}
            </Space>
          </Spin>
        )}
      </div>
    </div>
  );
};

export default EstimationCard;
